import { render, staticRenderFns } from "./DialogCobranca.vue?vue&type=template&id=b74535e4"
import script from "./DialogCobranca.vue?vue&type=script&lang=js"
export * from "./DialogCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports